import React from 'react';
import ReactDOM from 'react-dom';
import './normalize.css'
import './index.css'

class About extends React.Component {
    render(){
        function createMarkup() {
          return {__html: `
            <div class="row intro">Ever wondered what it takes to create a webpage? Try changing the <span class="orange">orange</span> values in the code below to see for yourself.</div>
            <div class="row"><span class="blue">class</span> <span class="green">App</span> <span class="blue">extends</span> <span class="green">React<span class="red">.</span></span>Component { </div>
            <div class="row indent-1">      <span class="green">constructor</span>() {</div>
            <div class="row indent-2">          <span class="green">super</span>()</div>
            <div class="row indent-2">          this<span class="yellow"><span class="red">.</span></span>state <span class="red">=</span> {</div>
            <div class="row indent-3">              <span class="yellow">name</span>: '<span class="orange" contenteditable="true" data-prop="name">Dominic Kelly</span>',</div>
            <div class="row indent-3">              <span class="yellow">jobTitle</span>: '<span class="orange" contenteditable="true" data-prop="jobTitle">Front End Developer</span>',</div>
            <div class="row indent-3">              <span class="yellow">yearsOfExperience</span>: <span class="orange" contenteditable="true" data-prop="yearsOfExperience">18</span>,</div>
            <div class="row indent-3">              <span class="yellow">interests</span>: [</div>
            <div class="row indent-4">                  '<span class="orange" contenteditable="true" data-prop="interests" data-interests-index="0">cooking</span>',</div>
            <div class="row indent-4">                  '<span class="orange" contenteditable="true" data-prop="interests" data-interests-index="1">watching motor sport</span>',</div>
            <div class="row indent-4">                  '<span class="orange" contenteditable="true" data-prop="interests" data-interests-index="2">immersing myself in family life</span>'</div>
            <div class="row indent-3">              ],</div>
            <div class="row indent-3">              <span class="yellow">mobileNumber</span>: '<span class="orange" contenteditable="true" data-prop="mobileNumber">07525851624</span>',</div>
            <div class="row indent-3">              <span class="yellow">emailAddress</span>: '<span class="orange" contenteditable="true" data-prop="emailAddress">dom@voodoodigital.co.uk</span>'</div>
            <div class="row indent-2">          }</div>
            <div class="row indent-2"> this<span class="red">.</span>handleTextChange <span class="red">=</span> this<span class="red">.</span>handleTextChange<span class="red">.</span><span class="green">bind</span>(this)</div>
            <div class="row indent-1">      }</div>

            <div class="row indent-1"><span class="green">handleTextChange</span>(e){</div>
            <div class="row indent-2">    <span class="blue">let</span> index</div>
            <div class="row indent-2">    <span class="red">if</span>(e<span class="red">.</span>target<span class="red">.</span><span class="green">getAttribute</span>('<span class="yellow">data-interests-index</span>') <span class="red">!==</span> <span class="purple">null</span>){</div>
            <div class="row indent-3">        index = e<span class="red">.</span>target<span class="red">.</span><span class="green">getAttribute</span>('<span class="yellow">data-interests-index</span>')</div>
            <div class="row indent-3">        <span class="blue">const</span> interests <span class="red">=</span> this<span class="red">.</span>state<span class="red">.</span>interests</div>
            <div class="row indent-3">        interests[index] <span class="red">=</span> e<span class="red">.</span>target<span class="red">.</span>textContent</div>
            <div class="row indent-3">        this<span class="red">.</span><span class="green">setState</span>({</div>
            <div class="row indent-4">            interests</div>
            <div class="row indent-3">        })</div>
            <div class="row indent-2">    }<span class="red">else</span>{</div>
            <div class="row indent-3">        this<span class="red">.</span><span class="green">setState</span>({</div>
            <div class="row indent-4">            [e<span class="red">.</span>target<span class="red">.</span><span class="green">getAttribute</span>('<span class="yellow">data-prop</span>')]: e<span class="red">.</span>target<span class="red">.</span>textContent</div>
            <div class="row indent-3">        })</div>
            <div class="row indent-2">    }</div>
            <div class="row indent-1">}</div>
            <div class="row indent-1">      <span class="green">render</span>() {</div>
            <div class="row indent-2">          <span class="blue">const</span> { name, jobTitle, yearsOfExperience, interests } <span class="red">=</span> this<span class="red">.</span>state</div>
            <div class="row indent-2">          <span class="red">return</span> (</div>
            <div class="row indent-3">              &lt;<span class="red">div</span> <span class="green">id</span><span class="red">=</span>"<span class="yellow">about</span>"&gt;</div>
            <div class="row indent-4">&lt;<span class="red">h1</span>&gt;Hi. I'm { name }, a passionate and multi-disciplined &lt;<span class="red">strong</span>>{ jobTitle }&lt;/<span class="red">strong</span>&gt; with { yearsOfExperience } years experience living in { location }.  When I’m not coding, I enjoy { interests[0] }, { interests[1] } and { interests[2] }.&lt;/<span class="red">h1</span>&gt;</div>
            <div class="row indent-4">&lt;<span class="red">p</span>&gt;&lt;<span class="red">a</span> <span class="green">href</span><span class="red">=</span>{<span class="yellow">&#96;tel</span>:{ <span class="yellow">mobileNumber</span> }&#96;}&gt;Call&lt;/<span class="red">a</span>&gt; me on { <span class="yellow">mobileNumber</span> }, or &lt;<span class="red">a</span> <span class="green">href</span><span class="red">=</span>{<span class="yellow">&#96;mail</span>:{ <span class="yellow">emailAddress</span> }&#96;}&gt;email&lt;/<span class="red">a</span>&gt; me  to discuss your project.&lt;/<span class="red">p</span>&gt;</div>
            <div class="row indent-3">              &lt;/<span class="red">div</span>&gt;</div>
            <div class="row indent-2">          )</div>
            <div class="row indent-1">      }</div>
             <div class="row new-line"> }</div>
             <div class="row">ReactDOM<span class="red">.</span><span class="green">render</span>(&lt;<span class="blue">App</span> /&gt;, <span class="blue">document</span><span class="red">.</span><span class="green">getElementById</span>('<span class="yellow">root</span>'))</div>
          `};
        }
        return(
            <div className="ui touch">
                <div dangerouslySetInnerHTML={createMarkup()} onInput={this.props.handleTextChange}/>
            </div>
        )
    }
}
class App extends React.Component {
    constructor(){
        super()
        this.state = {
            name: 'Dominic Kelly',
            jobTitle: 'Front End Developer',
            yearsOfExperience: 18,
            location: 'Leeds',
            interests: [
                'cooking',
                'watching motor sport',
                'immersing myself in family life'
            ],
            mobileNumber: '07525851624',
            emailAddress: 'dom@voodoodigital.co.uk'
        }
        this.handleTextChange = this.handleTextChange.bind(this)
    }
    handleTextChange(e){
        let index
        if(e.target.getAttribute('data-interests-index') !== null){
            index = e.target.getAttribute('data-interests-index')
            const interests = this.state.interests
            interests[index] = e.target.textContent
            this.setState({
                interests
            })
        }else{
            this.setState({
                [e.target.getAttribute('data-prop')]: e.target.textContent
            })
        }
    }
    render() {
        const { name, jobTitle, yearsOfExperience,  location, interests, mobileNumber, emailAddress } = this.state
        return (
            <div id="about">
                <h1>Hi. I'm { name }, a passionate and multi-disciplined <strong>{ jobTitle }</strong> with { yearsOfExperience } years experience living in { location }.  When I’m not coding, I enjoy { interests[0] }, { interests[1] } and { interests[2] }.</h1>
                <p><a href={`tel:${ mobileNumber }`}>Call</a> me on { mobileNumber }, or <a href={`mailto:${ emailAddress }`}>email</a> me  to discuss your project.</p>
                <About handleTextChange={this.handleTextChange}/>
            </div>
        )
    }
}

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js